import { render } from "./Content.vue?vue&type=template&id=55c38319&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=55c38319&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/www/grand-place-des-guinzes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c38319"]])

export default __exports__